import { Component } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

/**
 * The merchant user guide: a PDF kept in Google Drive, shown in Drive's own
 * viewer.
 *
 * Kept in Drive rather than in this app so it can be updated without a
 * deploy - replace it in Drive with "Manage versions > Upload new version",
 * which keeps the file id, and this page shows the new copy. Uploading a new
 * file instead gives it a new id and this page keeps showing the old one.
 *
 * The file must be shared as "Anyone with the link can view", or merchants see
 * a Google sign-in box where the guide should be.
 */
const DRIVE_FILE_ID = "130_UVqFnUywFPbPn-3R676W29N5eyisQ";

@Component({
  selector: "fh-user-guide",
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: "./user-guide.component.html",
  styles: `
  /* The viewer's box on the page: unchanged in size. */
  .user-guide-box {
    position: relative;
    width: 100%;
    /* A frame does not size itself to the document: fill most of the screen
       and let the viewer scroll inside it. */
    height: calc(100vh - 260px);
    min-height: 480px;
    margin-top: 16px;
    overflow: hidden;
    border-radius: 8px;
    background: #f5f5f5;
  }

  /*
   * Zoomed in. Drive's embed viewer always fits the page to the frame's width
   * and takes no zoom setting, so the frame is drawn at 1/ZOOM of the box and
   * scaled back up to fill it: the box stays the same size and everything
   * inside - the guide and Drive's toolbar - is ZOOM times larger.
   */
  .user-guide-frame {
    --zoom: 1.25;
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% / var(--zoom));
    height: calc(100% / var(--zoom));
    border: 0;
    transform: scale(var(--zoom));
    transform-origin: top left;
  }
  `,
})
export class UserGuideComponent {
  /** Opens in a new tab - on a phone, a framed PDF is fiddly to scroll. */
  readonly openUrl = `https://drive.google.com/file/d/${DRIVE_FILE_ID}/view`;
}
